const breadcrumb = {
  state: {
    listBreadcrumb: [],
  },
  mutations: {
    setListBreadcrumb(state, val) {
      state.listBreadcrumb = val
    },
  },
  actions: {},
  getters: {
    getListBreadcrumb(state) {
      return state.listBreadcrumb
    },
  },
}
export default breadcrumb
